import React from "react";
import PropTypes from "prop-types";
import "./Textarea.scss";

const Textarea = ({
  id,
  name,
  value,
  onChange,
  placeholder,
  rows,
  disabled,
  required,
  maxLength,
  className,
}) => {
  return (
    <div className={`textarea ${className || ""}`}>
      <textarea
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        rows={rows}
        disabled={disabled}
        required={required}
        maxLength={maxLength}
        className="textarea__input"
      />
    </div>
  );
};

Textarea.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  rows: PropTypes.number,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  maxLength: PropTypes.number,
  className: PropTypes.string,
};

Textarea.defaultProps = {
  id: undefined,
  placeholder: "Wpisz swoją odpowiedź",
  rows: 4,
  disabled: false,
  required: false,
  maxLength: undefined,
  className: "",
};

export default Textarea;
